import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../../context/authContext";
import useDocumentTitle from "../../../../hooks/useDocumentTitle";

const PageWrapper = (props) => {
  const { children, className, isProtectedRoute = true, title, name, ...rest } = props;

  useDocumentTitle({ title, name });

  const { usernameStorage } = useAuth();
  // if (isProtectedRoute && !usernameStorage) {
  // 	// user is not authenticated
  // 	return <Navigate to={"/"} />;
  // }
  return (
    <main data-component-name="PageWrapper" className={classNames("flex shrink-0 grow flex-col", className)} {...rest}>
      {children}
    </main>
  );
};

export default PageWrapper;
